module.exports = __webpack_public_path__ + "img/black.be5030ca.webp";